import SearchSVG from '@public/icons/search.svg';
import { InputHTMLAttributes } from 'react';
import Input from '../Input';

function SearchInput({ value, onInput, placeholder }: InputHTMLAttributes<HTMLInputElement>) {
    return (
        <div className="search-input-wrapper">
            <Input
                value={value}
                onInput={onInput}
                label="search"
                hideLabel
                className="search-input text-xs"
                placeholder={placeholder}
                showMessage={false}
            />
            <button className="search-input-btn" aria-label="Искать">
                <SearchSVG />
            </button>
        </div>
    );
}

export default SearchInput;
